import { render, staticRenderFns } from "./ManagementLandingCustom.vue?vue&type=template&id=49fed1fe&scoped=true&"
import script from "./ManagementLandingCustom.vue?vue&type=script&lang=ts&"
export * from "./ManagementLandingCustom.vue?vue&type=script&lang=ts&"
import style0 from "./ManagementLandingCustom.vue?vue&type=style&index=0&id=49fed1fe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49fed1fe",
  null
  
)

export default component.exports